import Axios from "axios";
import {
  SET_INV_DIRECT_RECEIVE_REPORT,
  UNSET_INV_DIRECT_RECEIVE_REPORT,
} from "@/store/mutation-types";
import { getInvDirectReceiveReport } from "@/store/api";

const state = {
  getInvDirectReceiveReport: {},
};

const getters = {
  getInvDirectReceiveReport(state) {
    return state.getInvDirectReceiveReport;
  },
};

const mutations = {
  [SET_INV_DIRECT_RECEIVE_REPORT](state, data) {
    state.getInvDirectReceiveReport = data;
  },
  [UNSET_INV_DIRECT_RECEIVE_REPORT](state) {
    state.getInvDirectReceiveReport = {};
  },
};

const actions = {
  getInvDirectReceiveReport({ commit }, params) {
    return new Promise((resolve, reject) => {
      Axios.get(getInvDirectReceiveReport, { params })
        .then(function (response) {
          commit("SET_INV_DIRECT_RECEIVE_REPORT", response.data);
          resolve(response);
        })
        .catch(function (error) {
          commit("UNSET_INV_DIRECT_RECEIVE_REPORT");
          reject(error);
        })
        .then((always) => {});
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
